<ng-container *ngFor="let errorMessage of data.errorMessages">
  <div class="error-block">
    <small class="error-block__text">{{ errorMessage }}</small>
  </div>
</ng-container>
